import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLazySelector } from 'hooks'
import { EventNotifications } from 'modules/Notifications/components'
import {
  loadUserHighlightedAndEventNotificationsData,
  setEventViewedState,
} from 'modules/Notifications/slices/notifications'
import { EventNotificationsUtils } from 'modules/Notifications/utils'

const EventNotificationsContainer: React.FC = () => {
  const dispatch = useDispatch()
  const { eventNotifications, eventViewed } = useLazySelector(({ notifications }) => {
    const { eventNotifications, eventViewed } = notifications
    return {
      eventNotifications,
      eventViewed,
    }
  })

  const storageEventNotificationsViewed =
    EventNotificationsUtils.getEventNotificationsState() === EventNotificationsUtils.viewed
  const eventNotificationsViewed = eventViewed || storageEventNotificationsViewed

  useEffect(() => {
    if (!eventNotifications) {
      dispatch(loadUserHighlightedAndEventNotificationsData())
    }
    dispatch(setEventViewedState(eventNotificationsViewed))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  function handleClose() {
    EventNotificationsUtils.markEventNotificationsViewed()
    dispatch(setEventViewedState(true))
  }

  const isShowNotification = !!eventNotifications?.length && !eventViewed

  return (
    <EventNotifications
      events={eventNotifications}
      onClose={handleClose}
      isShow={isShowNotification}
    />
  )
}

export default EventNotificationsContainer
